export const locales = ["nl", "en"] as const;
export type Locale = (typeof locales)[number];
export type Localized = { nl: string; en: string };
export const L = (nl: string, en: string): Localized => ({ nl, en });
export const isLocale = (value: string): value is Locale =>
  locales.includes(value as Locale);
export const messages = {
  workQueue: L("Werkvoorraad", "Work queue"),
  dashboard: L("Dashboard", "Dashboard"),
  clients: L("Cliënten", "Clients"),
  communication: L("Communicatie", "Communication"),
  bank: L("Bank & accorderen", "Banking & approvals"),
  mailroom: L("Postkamer", "Mailroom"),
  invoicing: L("Facturatie", "Invoicing"),
  court: L("Rechtspraak & R&V", "Court & reporting"),
  forms: L("Formulieren & instanties", "Forms & authorities"),
  portal: L("Cliëntportaal", "Client portal"),
  reports: L("Rapportage & kwaliteit", "Reports & quality"),
  knowledge: L("Kennisbank", "Knowledge base"),
  settings: L("Beheer & AI-kaders", "Settings & AI policies"),
  budget: L("Budgetplan", "Budget plan"),
  debts: L("Schulden & regelingen", "Debts & arrangements"),
  client: L("Klantenkaart", "Client record"),
  moneyMail: L("Geld & post", "Money & mail"),
  external: L("Extern", "External"),
  office: L("Kantoor", "Office"),
  workspace: L("Van den Bosse", "Van den Bosse"),
  demo: L("Demo · fictieve gegevens", "Demo · fictional data"),
  demoNote: L(
    "Dit is een interactief ontwerp. Wijzigingen blijven in deze sessie; er worden geen betalingen of berichten verstuurd.",
    "This is an interactive design. Changes stay in this session; no payments or messages are sent.",
  ),
  search: L(
    "Zoek cliënt, dossier of scherm…",
    "Search clients, case files or screens…",
  ),
  noResults: L("Geen resultaten gevonden", "No results found"),
  new: L("Nieuw", "New"),
  assistant: L("Assistent", "Assistant"),
  notifications: L("Meldingen", "Notifications"),
  audit: L("Activiteitenlog", "Activity log"),
  menu: L("Menu openen", "Open menu"),
  close: L("Sluiten", "Close"),
  language: L("Taal", "Language"),
  skip: L("Naar inhoud", "Skip to content"),
  profile: L("Jasper Klaassen · behandelaar", "Jasper Klaassen · case handler"),
  greeting: L("Goedemorgen Jasper", "Good morning Jasper"),
  queueSub: L(
    "items vragen om jouw besluit. De rest is al geregeld.",
    "items need your decision. The rest is taken care of.",
  ),
  today: L("Voor jou vandaag", "For you today"),
  awaiting: L("Wacht op tweede akkoord", "Awaiting second approval"),
  automated: L("Automatisch afgehandeld (24 u)", "Automatically handled (24h)"),
  deadlines: L("Deadlines deze week", "Deadlines this week"),
  all: L("Alles", "All"),
  post: L("Post", "Mail"),
  bankFilter: L("Bank", "Bank"),
  highOnly: L("Alleen hoog", "High priority"),
  selectAll: L("Selecteer alles", "Select all"),
  selected: L("geselecteerd", "selected"),
  approve: L("Akkoord", "Approve"),
  approveRun: L("Akkoord, voer uit", "Approve & apply"),
  edit: L("Aanpassen", "Edit"),
  own: L("Zelf doen", "Handle manually"),
  proposal: L("Voorstel", "Proposal"),
  sources: L("Bronnen bekijken", "View sources"),
  high: L("Hoog", "High"),
  medium: L("Middel", "Medium"),
  low: L("Laag", "Low"),
  export: L("Export", "Export"),
  sort: L("Prioriteit", "Priority"),
  latest: L("Nieuwste eerst", "Newest first"),
  emptyQueue: L("Alles onder controle", "All caught up"),
  emptyQueueSub: L(
    "Er zijn geen open items voor dit filter.",
    "There are no open items for this filter.",
  ),
  activity: L("Terwijl jij er niet was", "While you were away"),
  activitySub: L(
    "Rust in je werk, ruimte voor de mens.",
    "Less administration, more time for people.",
  ),
  viewAll: L("Alles bekijken", "View all"),
  policiesHint: L(
    "Jij bepaalt de kaders. Elke AI-actie heeft een bron en blijft onder jouw controle.",
    "You set the boundaries. Every AI action has a source and stays under your control.",
  ),
  upcoming: L("Binnenkort", "Coming up"),
  details: L("Details", "Details"),
  cancel: L("Annuleren", "Cancel"),
  save: L("Opslaan", "Save"),
  done: L("Gereed", "Done"),
  back: L("Terug", "Back"),
  name: L("Naam", "Name"),
  caseFile: L("Dossier", "Case file"),
  type: L("Type", "Type"),
  phase: L("Trajectfase", "Stage"),
  handler: L("Behandelaar", "Case handler"),
  signals: L("Signalen", "Signals"),
  status: L("Status", "Status"),
  amount: L("Bedrag", "Amount"),
  date: L("Datum", "Date"),
  description: L("Omschrijving", "Description"),
  clientName: L("Cliënt", "Client"),
  newClient: L("Nieuw dossier", "New case file"),
  clientsSub: L(
    "Overzicht van je cliënten. Alles wat je nodig hebt, één klik verder.",
    "An overview of your clients. Everything you need, one click away.",
  ),
  myFiles: L("Mijn dossiers", "My case files"),
  wholeOffice: L("Hele kantoor", "Whole office"),
  withSignals: L("Met signalen", "With signals"),
  activeFiles: L("Actieve dossiers", "Active case files"),
  showing: L("getoond", "shown"),
  guardianship: L("Bewind", "Guardianship"),
  debtSupport: L("Bewind + SHV", "Guardianship + debt support"),
  budgetManagement: L("Budgetbeheer", "Budget management"),
  mentoring: L("Mentorschap", "Mentoring"),
  stable: L("Stabiel", "Stable"),
  intake: L("Intake", "Intake"),
  arrangement: L("Schuldregeling", "Debt arrangement"),
  stabilization: L("Stabilisatie", "Stabilisation"),
  note: L("Notitie", "Note"),
  message: L("Bericht", "Message"),
  balance: L("Saldo", "Balance"),
  available: L("Beschikbaar", "Available"),
  reserved: L("Gereserveerd", "Reserved"),
  timeline: L("Tijdlijn", "Timeline"),
  documents: L("Documenten", "Documents"),
  financial: L("Financieel", "Financial"),
  notes: L("Notities", "Notes"),
  summary: L("Dossiersamenvatting", "Case summary"),
  involved: L("Betrokkenen", "People involved"),
  sections: L("Onderdelen van dit dossier", "Explore this case file"),
  trajectory: L("Traject · schuldhulpverlening", "Journey · debt support"),
  debtFree: L("Schuldenvrij", "Debt free"),
  completion: L("Afronding", "Completion"),
  balanceTrend: L("Saldoverloop · 12 maanden", "Balance over 12 months"),
  accounts: L("Rekeningen", "Accounts"),
  expenses: L("Uitgaven", "Expenses"),
  income: L("Inkomsten", "Income"),
  history: L("Historie", "History"),
  category: L("Rubriek", "Category"),
  frequency: L("Termijn", "Frequency"),
  actual: L("Werkelijk", "Actual"),
  onTrack: L("Op schema", "On track"),
  monthly: L("Maand", "Month"),
  weekly: L("Week", "Week"),
  reservations: L("Reserveringen", "Reservations"),
  addBudget: L("Budgetregel toevoegen", "Add budget rule"),
  review: L("Controleren", "Review"),
  recipient: L("Ontvanger", "Recipient"),
  origin: L("Herkomst", "Origin"),
  check: L("Controle", "Check"),
  approvals: L("Accorderen", "Approvals"),
  batches: L("Betaalbatches", "Payment batches"),
  transactions: L("Transacties", "Transactions"),
  rules: L("Rubriceerregels", "Categorisation rules"),
  counterparties: L("Tegenrekeningen", "Counterparties"),
  approveSelection: L("Accordeer selectie", "Approve selection"),
  reject: L("Afwijzen", "Reject"),
  verified: L("Geverifieerd", "Verified"),
  blocked: L("Geblokkeerd", "Blocked"),
  fourEyes: L(
    "Vier ogen: Sanne V. heeft deze betalingen klaargezet. Jij controleert als tweede behandelaar. Nieuwe tegenrekeningen blijven geblokkeerd.",
    "Four eyes: Sanne V. prepared these payments. You review them as the second handler. New counterparties remain blocked.",
  ),
  upload: L("Upload", "Upload"),
  inbox: L("Inbox", "Inbox"),
  document: L("Document", "Document"),
  match: L("Dossiermatch", "Case match"),
  action: L("Actievoorstel", "Proposed action"),
  extracted: L("Gelezen & geëxtraheerd", "Read & extracted"),
  sender: L("Afzender", "Sender"),
  reference: L("Kenmerk", "Reference"),
  dueDate: L("Vervaldatum", "Due date"),
  archive: L("Archiveren", "Archive"),
  processed: L("Verwerkt", "Processed"),
  creditor: L("Schuldeiser", "Creditor"),
  collector: L("Incasseerder", "Collector"),
  remaining: L("Restant", "Remaining"),
  capacity: L("Afloscapaciteit", "Repayment capacity"),
  debtList: L("Schuldenlijst", "Debt register"),
  repayment: L("Aflossing", "Repayment"),
  courtName: L("Rechtbank", "Court"),
  deadline: L("Deadline", "Deadline"),
  draft: L("Concept", "Draft"),
  periods: L("R&V-perioden", "Reporting periods"),
  cases: L("Zaken", "Cases"),
  requests: L("Verzoeken", "Requests"),
  messages: L("Berichten", "Messages"),
  inventory: L("Boedel & evaluaties", "Inventory & evaluations"),
  generate: L("Genereer", "Generate"),
  institution: L("Instantie", "Authority"),
  library: L("Instantiebibliotheek", "Authority library"),
  recent: L("Laatst gegenereerd", "Recently generated"),
  requestExtra: L("Extra leefgeld vragen", "Request extra spending money"),
  sendDocument: L("Document sturen", "Send a document"),
  chatOffice: L("Chat met kantoor", "Chat with the office"),
  spendingMoney: L("Leefgeld deze week", "Spending money this week"),
  deposited: L("Gestort", "Deposited"),
  home: L("Home", "Home"),
  profiles: L("Profielen", "Profiles"),
  channel: L("Kanaal", "Channel"),
  lastMessage: L("Laatste bericht", "Last message"),
  sentiment: L("Sentiment", "Sentiment"),
  conversations: L("Gesprekken", "Conversations"),
  send: L("Verstuur", "Send"),
  reply: L("Schrijf een reactie…", "Write a reply…"),
  invoice: L("Factuur", "Invoice"),
  invoices: L("Facturen", "Invoices"),
  subscriptions: L("Abonnementen", "Subscriptions"),
  newInvoice: L("Nieuwe factuur", "New invoice"),
  paid: L("Betaald", "Paid"),
  sent: L("Verzonden", "Sent"),
  overdue: L("Achterstallig", "Overdue"),
  reportLibrary: L("Rapportbibliotheek", "Report library"),
  report: L("Rapport", "Report"),
  for: L("Voor", "For"),
  quality: L("Kwaliteitsmonitor", "Quality monitor"),
  generateReport: L("Maak rapport", "Create report"),
  question: L(
    "Stel een vraag over je cijfers…",
    "Ask a question about your numbers…",
  ),
  articles: L("Werkinstructies", "Work instructions"),
  owner: L("Eigenaar", "Owner"),
  reliability: L("Betrouwbaarheid", "Reliability"),
  current: L("Actueel", "Current"),
  flagged: L("Controle nodig", "Needs review"),
  open: L("Openen", "Open"),
  flag: L("Meld verouderde informatie", "Flag outdated information"),
  faq: L("Veelgestelde vragen", "Frequently asked questions"),
  newArticle: L("Nieuw artikel", "New article"),
  policies: L("AI-beleidsregels", "AI policies"),
  automatic: L("Automatisch", "Automatic"),
  suggest: L("Voorstellen", "Suggest"),
  manual: L("Handmatig", "Manual"),
  locked: L("Vergrendeld", "Locked"),
  roles: L("Rollen & rechten", "Roles & permissions"),
  users: L("Gebruikers", "Users"),
  integrations: L("Integraties", "Integrations"),
  connected: L("Verbonden", "Connected"),
  preferences: L("Voorkeuren", "Preferences"),
  defaultLanguage: L("Weergavetaal", "Display language"),
  title: L("Titel", "Title"),
  content: L("Inhoud", "Content"),
  reason: L("Reden", "Reason"),
  confirm: L("Bevestigen", "Confirm"),
  sourcesTitle: L("Bronnen van dit voorstel", "Sources for this proposal"),
  sourceNote: L(
    "Voorbeeldbronnen uit het ontwerpprototype. Controleer altijd de oorspronkelijke documenten voordat je een besluit neemt.",
    "Sample sources from the design prototype. Always review the original documents before making a decision.",
  ),
  localSaved: L("Opgeslagen in deze demosessie", "Saved in this demo session"),
  localApproved: L(
    "Voorstel verwerkt in deze demosessie",
    "Proposal applied in this demo session",
  ),
  localSent: L(
    "Bericht toegevoegd aan het demogesprek",
    "Message added to the demo conversation",
  ),
  noActivity: L(
    "Nog geen wijzigingen in deze sessie.",
    "No changes in this session yet.",
  ),
  assistantIntro: L(
    "Ik help je het overzicht te bewaren. Kies hieronder een voorbeeldvraag om deze demo te verkennen.",
    "I help you keep an overview. Choose a sample question below to explore this demo.",
  ),
  assistantDemo: L(
    "Demo-assistent · voorbeeldantwoorden",
    "Demo assistant · sample responses",
  ),
  summaryQuestion: L("Vat dossier 0143 samen", "Summarise case file 0143"),
  deadlinesQuestion: L(
    "Welke deadlines komen eraan?",
    "Which deadlines are coming up?",
  ),
  helpQuestion: L(
    "Hoe werkt de werkvoorraad?",
    "How does the work queue work?",
  ),
  noClient: L("Dit dossier is niet gevonden.", "This case file was not found."),
  uploadHint: L(
    "PDF, PNG of JPG · maximaal 10 MB. Alleen de bestandsnaam wordt in deze demo bewaard.",
    "PDF, PNG or JPG · up to 10 MB. Only the filename is kept in this demo.",
  ),
  fileTooLarge: L(
    "Kies een PDF of afbeelding van maximaal 10 MB.",
    "Choose a PDF or image up to 10 MB.",
  ),
  demoConfirm: L(
    "Dit past alleen de demo aan. Er wordt niets extern verstuurd.",
    "This only updates the demo. Nothing is sent externally.",
  ),
  confirmPayment: L(
    "Geselecteerde betalingen controleren",
    "Review selected payments",
  ),
  paymentNotice: L(
    "Alleen geverifieerde betalingen kunnen worden geaccordeerd. Dit simuleert de tweede controle; er wordt geen bankopdracht aangemaakt.",
    "Only verified payments can be approved. This simulates the second review; no bank instruction is created.",
  ),
  empty: L("Geen items gevonden.", "No items found."),
  preview: L("Voorbeeld", "Preview"),
  download: L("Download", "Download"),
  updated: L("Bijgewerkt", "Updated"),
  intro: L("Jouw overzicht voor vandaag", "Your overview for today"),
  active: L("Actief", "Active"),
  preferenceSaved: L(
    "Je taalkeuze wordt onthouden op dit apparaat.",
    "Your language preference is remembered on this device.",
  ),
} satisfies Record<string, Localized>;
export type MessageKey = keyof typeof messages;
export const formatMoney = (locale: Locale, cents: number) =>
  new Intl.NumberFormat(locale === "nl" ? "nl-NL" : "en-GB", {
    style: "currency",
    currency: "EUR",
  }).format(cents / 100);
export const formatDate = (
  locale: Locale,
  value: string,
  options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  },
) =>
  new Intl.DateTimeFormat(locale === "nl" ? "nl-NL" : "en-GB", {
    ...options,
    timeZone: "Europe/Amsterdam",
  }).format(new Date(`${value}T12:00:00Z`));
